module.exports = __webpack_public_path__ + "static/media/1_A1_24.7f749294.png";